 <template>
	<div
		class="info-button"
		role="button"
		tabindex="0"
		@click="toggleCloud"
		@keyup.enter.prevent="toggleCloud"
		@keyup.space.prevent="toggleCloud"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave">
		<div class="icon-container" v-html="svgStore.iconInfo"></div>
		<AppInPlaceCloud ref="cloud" :active="cloudActive" @close-cloud="closeCloud">
			<slot></slot>
		</AppInPlaceCloud>
	</div>
</template>

<script>
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import {useSvgStore} from "@/shared/stores";

export default {
	name: "AppInfoButton",
	components: {AppInPlaceCloud},
	computed: {
		svgStore() { return useSvgStore(); }
	},
	data() {
		return {
			cloudActive: false,
			hoverTimeout: null,
		}
	},
	mounted() {
		// Add click-outside listener for all devices
		document.addEventListener('click', this.handleClickOutside, true);
	},
	methods: {
		toggleCloud() {
			this.cloudActive = !this.cloudActive;
		},
		onMouseEnter() {
			// Only show on hover if device supports hover (not touch)
			// This is checked dynamically via matchMedia, so it works with Chrome DevTools emulation
			if (!window.matchMedia('(hover: hover)').matches) {
				return; // Don't show on hover for touch devices
			}
			if (this.hoverTimeout) {
				clearTimeout(this.hoverTimeout);
			}
			this.cloudActive = true;
		},
		onMouseLeave() {
			// Only hide on hover if device supports hover (not touch)
			if (!window.matchMedia('(hover: hover)').matches) {
				return; // Don't hide on hover for touch devices
			}
			this.hoverTimeout = setTimeout(() => {
				this.cloudActive = false;
			}, 200);
		},
		closeCloud() {
			// Called by @close-cloud event (e.g., on scroll)
			// This should always work regardless of device type
			if (this.hoverTimeout) {
				clearTimeout(this.hoverTimeout);
			}
			this.cloudActive = false;
		},
		handleClickOutside(event) {
			// Close cloud when clicking outside
			if (this.cloudActive) {
				// Check if click is outside the info button and cloud
				const infoButton = this.$el;
				const cloud = this.$refs.cloud?.$refs['inner-cloud'];

				if (infoButton && !infoButton.contains(event.target)) {
					if (!cloud || !cloud.contains(event.target)) {
						this.cloudActive = false;
					}
				}
			}
		}
	},
	beforeUnmount() {
		if (this.hoverTimeout) {
			clearTimeout(this.hoverTimeout);
		}
		// Remove click-outside listener
		document.removeEventListener('click', this.handleClickOutside, true);
	}
}
</script>

<style lang="scss" scoped>
.info-button {
	width: 24px;
	height: 30px;
	background: transparent;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: relative;

	.icon-container {
		width: 14px;
		height: 14px;
		display: flex;
		align-items: center;
		justify-content: center;

		:deep(svg) {
			width: 14px;
			height: 14px;

			.fill {
				fill: $txt_1;
				transition: fill 0.2s ease;
			}
		}
	}
}
</style>